import React, { FC } from "react"
import { FormattedMessage } from "react-intl"
import messages from "messages/home"

import { links } from "constants/links"
import ExternalLink from "components/ExternalLink"
import CryptoCard from "assets/images/HomePage/CryptoCard.webp"
import styles from "./index.module.scss"

const Partners: FC = () => (
	<section className={styles.cryptoCards}>
		<h2 className="visually-hidden">Partners</h2>

		<div className={styles.cryptoCards__container}>
			<div className={styles.cryptoCards__circle} />

			<div className={styles.cryptoCards__gradient}>
				<p className={styles.cryptoCards__headline}>
					<FormattedMessage {...messages.revolutionary} />
				</p>

				<p className={styles.cryptoCards__content}>
					<FormattedMessage {...messages.revolutionary_description} />
				</p>

				<ExternalLink to={links.card}>
					<button className={styles.cryptoCards__button} disabled type="button">
						<FormattedMessage {...messages.coming_soon_q3_in} />
					</button>
				</ExternalLink>

				<img
					className={styles.cryptoCards__img}
					src={CryptoCard}
					alt="Your Revolutionary Crypto Card"
				/>
			</div>
		</div>
	</section>
)

export default Partners
